import { Box, Button, LeftIcon, RightIcon, Stack, useTheme } from "@carrotfertility/carotene-core"
import React, { ReactNode } from "react"
import { FormattedMessage } from "react-intl"

export function SkipButton({
  children,
  onClick
}: {
  children: ReactNode | ReactNode[]
  onClick: () => void
}): JSX.Element {
  return (
    <Button onClick={onClick} color="secondary" variant="text">
      {children}
    </Button>
  )
}

export function ContinueButton({
  children,
  onClick,
  disabled
}: {
  children: ReactNode | ReactNode[]
  onClick?: (val?: any) => void
  disabled?: boolean
}): JSX.Element {
  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      type="submit"
      color="secondary"
      variant="outlined"
      endIcon={<RightIcon />}
    >
      {children}
    </Button>
  )
}

export function RegistrationButtonFooter({
  continueButton,
  skipButton,
  onBack
}: {
  continueButton: ReactNode
  skipButton?: ReactNode
  onBack?: () => void
}): JSX.Element {
  const theme = useTheme()

  return (
    <Box
      marginTop={(theme) => theme.spacing(theme.tokens.spacing.xl)}
      display="flex"
      justifyContent={onBack ? "space-between" : "flex-end"}
    >
      {onBack ? (
        <Button onClick={onBack} variant="text" color="secondary" startIcon={<LeftIcon />}>
          <FormattedMessage defaultMessage="Back" />
        </Button>
      ) : null}
      <Stack direction="row" spacing={theme.spacing(theme.tokens.spacing.sm)}>
        {skipButton}
        {continueButton}
      </Stack>
    </Box>
  )
}
